import { jsx as _jsx } from "react/jsx-runtime";
import { FileUploadKeyboardShortcut } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/FileUploadKeyboardShortcut.js';
import { useFilePicker } from '#pplx/frontend/composer-sdk/file-picker/useFilePicker.js';
import { useComposer } from '#pplx/frontend/composer-sdk/useComposer.js';
export function FileAttachmentKeyboardShortcut({ gateUploadFile, }) {
    const { open } = useFilePicker();
    const { isDisabled } = useComposer();
    if (isDisabled)
        return null;
    return _jsx(FileUploadKeyboardShortcut, { gateUploadFile: gateUploadFile, onOpenFilePicker: open });
}
//# sourceMappingURL=FileAttachmentKeyboardShortcut.js.map